import React from 'react';
import { Stack, useTheme } from '@mui/material';

import { VTypography } from '@venti-components';
import { ReactComponent as MercadoPagoIcon } from '../../../assets/paymentMethods/mercadoPago.svg';
import Installments from './common/installments';

const MercadoPagoPaymentMethod = ({ paymentOption }) => {
  const theme = useTheme();
  return (
    <Stack className="methodLabel">
      <MercadoPagoIcon className="mainIcon" />
      <Stack direction="column" gap={0}>
        <VTypography variant="body1">Mercado Pago</VTypography>
        <Installments installments={paymentOption?.installments} />
        <VTypography variant="body2" color={theme.palette.text.secondary}>
          Tarjeta de crédito, débito o dinero en cuenta
        </VTypography>
      </Stack>
    </Stack>
  );
};

export default MercadoPagoPaymentMethod;
